import { useState } from 'react'
import useEventBus from './useEventBus'

export default formName => {
  const [isComponentFormValid, setComponentFormValid] = useState(false)
  useEventBus('FormValidated', event => {
    const { form, isValid } = event
    if (form === formName) {
      setComponentFormValid(isValid)
    }
  })

  return isComponentFormValid
}
